export default "/_nuxt/8d8ad8189ec8afd08ee48414a1149942.svg";